import { useEffect, useState } from 'react';
import './static-info.css';
import { useForm } from 'react-hook-form';
import QuoteForm from './forms/quote-form';
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import AwbForm from './forms/awb-form';
import navBarEn from "../../../translations/en/navbar.json";
import navBarEs from "../../../translations/es/navbar.json";
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Loader from '../../../components/loader/loader';

function StaticInfo() {
  const [tTrack] = useTranslation("trackPage")
  const [tHome] = useTranslation("homePage");
  const [tNabvar] = useTranslation("navbar");
  const [textHome, setTextHome] = useState({"titulo-header":{"third-title":"","principal-title":"","secondary-title":""}})
  const idHome = '29016553-ee6b-45ee-aafe-6e451d29e398';
  const [statusBtn, setStatusBtn] = useState("quote");
  const navigate = useNavigate();
  const [statePass, setStatePass] = useState(true);
  const {
    handleSubmit,
    register,
    setValue,
    watch
  } = useForm();
  const [tSGetQuoteStepOne] = useTranslation("getQuoteStepOne");
  const listServices = tSGetQuoteStepOne("services", { returnObjects: true });
  const [stations, setStations] = useState([]);
  const [services, setServices] = useState([]);
  let currentLng = "es";

  if (stations.length !== 0) {
    localStorage.setItem("stations", JSON.stringify(stations));
  }

  if (services.length !== 0) {
    localStorage.setItem("services", JSON.stringify(services));
  } else {
    localStorage.setItem("services", JSON.stringify(listServices));
  }

  const getTexts = async () => {
    let currentLng = ''
    localStorage.getItem("lng") ? currentLng = `${localStorage.getItem("lng")}` : currentLng = 'es';
    try {
      const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idHome}`, {headers: {
        Authorization: process.env.REACT_APP_PUBLIC_KEY
      }});
      
      if(currentLng === 'es') {
        setTextHome(response.data.textWeb.text_es);
      } else {
        setTextHome(response.data.textWeb.text_us);
      }

    }catch(error) {
      setTextHome(null);
      console.error(error);
    }
  }

  const getStations = async () => {
    if (localStorage.getItem("lng")) {
      currentLng = localStorage.getItem("lng");
    }
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/stations?lng=${currentLng}`,
        {
          headers: {
            authorization: process.env.REACT_APP_PUBLIC_KEY, // Agrega la cadena de texto para la authorization en endponids publicos"
          },
        }
      );

      if (res.data.code === 1) {
        let data = res.data.stations
          .filter((station) => station.add_quote === 1)
          .sort((a, b) => {
            const isMEXA = a.code_text.startsWith("MEX");
            const isMEXB = b.code_text.startsWith("MEX");

            const isEdoMexA = a.name.toLowerCase().startsWith("edomex");
            const isEdoMexB = b.name.toLowerCase().startsWith("edomex");

            if (isMEXA && !isMEXB) return -1;
            if (!isMEXA && isMEXB) return 1;

            if (isMEXA && isMEXB) {
              if (isEdoMexA && !isEdoMexB) return 1;
              if (!isEdoMexA && isEdoMexB) return -1;

              const numA = parseInt(a.code_text.substring(3), 10);
              const numB = parseInt(b.code_text.substring(3), 10);
              return numA - numB;
            }

            if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
            if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;

            return 0;
          });
        setStations(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getServices = async () => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/services`,
        {
          headers: {
            authorization: process.env.REACT_APP_PUBLIC_KEY, // Agrega la cadena de texto para la authorization en endponids publicos"
          },
        }
      );
      if (res.data.code === 1) {
        const data = res.data.services;

        if (currentLng === "es") {
          const servicesEs = [];
          data.forEach((service) => {
            servicesEs.push(service.service_es);
          });
          setServices(servicesEs);
        } else if (currentLng === "us") {
          const servicesUs = [];
          data.forEach((service) => {
            servicesUs.push(service.service_us);
          });
          setServices(servicesUs);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleFormSubmit = async (data) => {
    if(statePass === true) {
      setStatePass(false);
    } else {
      return;
    }
    if(statusBtn === "quote") {
      setStatePass(true);
      if(
        data.departure === tHome("quote-shipping-form.select-dep-opt") || 
        data.arrival === tHome("quote-shipping-form.select-arr-opt") || 
        data.service === tHome("quote-shipping-form.select-service-opt")
      ) {
        return;
      }
      navigate("/quote", { state: { origin: data.departure, destino: data.arrival, service: data.service }});
    } else {
      const fetchDataTrack = async () => {
        let redirectPage = '';
        if(localStorage.getItem("lng")) {
          if(localStorage.getItem("lng") === 'us') {
            redirectPage = `${navBarEn["category-services"].track}`;
          } else {
            redirectPage = `${navBarEs["category-services"].track}`;
          }
        } else {
          redirectPage = `${navBarEs["category-services"].track}`;
        }
        try {
          if (!data.prefix || !data.waybillNumber) {
            setStatePass(true);
            return;
          }
          const url = `${process.env.REACT_APP_URL_BACKEND}/api/track/v4/${data.prefix}/${data.waybillNumber}`;
          const response = await axios.get(url);
  
          navigate(`${redirectPage}/${tTrack("result")}/${data.prefix}-${data.waybillNumber}`, 
              {state: {formData: {
                  prefix: data.prefix, 
                  waybillNumber: data.waybillNumber, 
                  data: response.data
              }}}
          );
  
        } catch (error) {
          if (error.response.data.message === "Track not found") {
            navigate(`${redirectPage}/track-not-found`, {state: {formData: {
              prefix: data.prefix, 
              waybillNumber: data.waybillNumber, 
              data: "error404"
            }}})
          } else if (error.response.data.message === "Track not information") {
            navigate(`${redirectPage}/track-not-info`, {state: {formData: {
              prefix: data.prefix, 
              waybillNumber: data.waybillNumber, 
              data: "notInformation"
            }}})
          } else if (error.response.data.message === "server error") {
            navigate(`${redirectPage}/track-not-info`, {state: {formData: {
              prefix: data.prefix, 
              waybillNumber: data.waybillNumber, 
              data: "serverError"
            }}})
          }
        }
      };
  
      fetchDataTrack();
    }
  }

  const handleRedirect = () => {
    if(statusBtn === "quote") {
      navigate(`/${tNabvar("category-services.quote")}`);
    } else if (statusBtn === "awb") {
      window.open(`https://www.deltacargo.com/Cargo/#/?selectedId=21`, "_blank")
    }
  }

  useEffect(() => {
    getTexts();
    getStations();
    getServices();
  }, []); 

  return (
    <>
      <div className='static-info'>
        <div className='title-home-content'>
          <span>{textHome?.["titulo-header"]?.["principal-title"] || tHome("header.principal-title")}</span>
          <p>{textHome?.["titulo-header"]?.["secondary-title"] || tHome("header.secondary-title")}</p>
          <p>{textHome?.["titulo-header"]?.["third-title"] || tHome("header.third-title")}</p>
        </div>

        <div className='btn-change-content'>
          <button className={statusBtn === 'quote' ? 'active' : ''} onClick={() => setStatusBtn('quote')}>{tHome("quote-shipping-form.title")}</button>
          <button className={statusBtn === 'awb' ? 'active' : ''} onClick={() => setStatusBtn('awb')}>{tHome("track-guide-form.title")}</button>
        </div>

        <div className='forms-content-home'>
          
          <form onSubmit={handleSubmit(handleFormSubmit)}>

            <div 
              className={`content-form ${statusBtn === "quote" ? 'quoteForm' : ''}`}
            >
              <QuoteForm register={register} setValue={setValue} />
            </div>

            <div 
              className={`content-form-awb ${statusBtn === "awb" ? 'awbForm' : ''}`}
            >
              <AwbForm register={register} setValue={setValue} watch={watch} />
            </div>

            <div className='btn-send-content'>
              <button type='submit' className={statusBtn}>
                {statusBtn === "quote" ? tHome("quote-shipping-form.btn-text") : statePass ? tHome("track-guide-form.btn-text") : "Cargando"} 
                {statePass ? <BsArrowRight /> : <Loader />}
              </button>

              <a onClick={handleRedirect} className={statusBtn}>
                {statusBtn === 'quote' ? tHome("quote-shipping-form.redirect-text") : tHome("track-guide-form.redirect-text")}
              </a>
            </div>

          </form>

        </div>

      </div>

    </>
  )
};

export default StaticInfo;